module.exports = __webpack_public_path__ + "static/media/book1.ccb90ca9.jpg";